module.exports = __webpack_public_path__ + "static/media/calendar.36f43188.svg";